import { render, staticRenderFns } from "./FavoritePage.vue?vue&type=template&id=a9b85c66&scoped=true"
import script from "./FavoritePage.vue?vue&type=script&lang=js"
export * from "./FavoritePage.vue?vue&type=script&lang=js"
import style0 from "./FavoritePage.vue?vue&type=style&index=0&id=a9b85c66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b85c66",
  null
  
)

export default component.exports